import * as React from "react";
function SvgUserCross(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50.43 53.27"
      ref={svgRef}
      {...props}
    >
      <path
        d="M37.37 40.4l-9-4.51a3.44 3.44 0 01-1.9-3.08v-3.53c.25-.29.54-.66.85-1.1a20.9 20.9 0 002.8-5.65 2.83 2.83 0 002-2.69v-3.78a2.82 2.82 0 00-.95-2.06V8.5S32.29 0 20.78 0 10.39 8.5 10.39 8.5V14a2.81 2.81 0 00-.95 2.09v3.78a2.83 2.83 0 001.31 2.37 18.73 18.73 0 003.42 7.07v3.45a3.43 3.43 0 01-1.79 3l-8.43 4.6A7.57 7.57 0 000 47v3.06h41.55v-2.88a7.57 7.57 0 00-4.18-6.78zm0 0"
        fill="#b4e8f9"
      />
      <path
        d="M43.17 16.3c-4 0-7.26 2.82-7.26 6.29A5.67 5.67 0 0037 26a5.15 5.15 0 01-1.27 1.44A5.68 5.68 0 0135 28l.18.77a6.75 6.75 0 001.17-.12 7.26 7.26 0 002.54-.95 8 8 0 004.31 1.24c4 0 7.26-2.82 7.26-6.29s-3.28-6.35-7.29-6.35z"
        fill="#b4e8f9"
      />
      <circle cx={35.65} cy={45.69} r={7.58} fill="#ed0c51" />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M32.84 42.88l5.62 5.62M38.46 42.88l-5.62 5.62"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserCross);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
